export function props(param) {
  if (!param) {
    return param;
  }
  if (Array.isArray(param)) {
    if (param.length === 2 && props[param[0]]) {
      return props[param[0]](param[1]);
    }
    return param.map(props);
  }
  if (props[param]) {
    return props[param]();
  }
  if (typeof param !== 'object') {
    return param;
  }
  return Object.entries(param).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: props(value),
    }),
    {},
  );
}

props.price = () => props.string({ length: 4 });
props.string = ({ length = 5 } = {}) => Array.from(new Array(length)).map(() => '1').join('');
props.array = ({ length, value }) => Array.from(new Array(length)).map(() => props(value));
